var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2222 22V9.77778H22V22H12.2222ZM0 12.2222V0H9.77778V12.2222H0ZM7.33333 9.77778V2.44444H2.44444V9.77778H7.33333ZM0 22V14.6667H9.77778V22H0ZM2.44444 19.5556H7.33333V17.1111H2.44444V19.5556ZM14.6667 19.5556H19.5556V12.2222H14.6667V19.5556ZM12.2222 0H22V7.33333H12.2222V0ZM14.6667 2.44444V4.88889H19.5556V2.44444H14.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f38fbcb8978e90312456f1107f86f5e2.svg";
export { ForwardRef as ReactComponent };